import { AxiosError } from "axios";
import { useAppInsights } from "./app-insights";

/** You can add your namespace */
type KasaLoggerSegmentNames = "kasa-apis" | "kasa-wheel-page";
type WebLoggerSegmentNames = "deh-general" | "bonusomat" | "golden-wheel";
type SazkabetLoggerSegmentNames = "furry-spin";
type AppLogggerSegmentNames = "all" | WebLoggerSegmentNames | KasaLoggerSegmentNames | SazkabetLoggerSegmentNames;

const { trackEvent, trackException, trackMetric } = useAppInsights();

/**
 *   You can combinate more segments separated by semicolon in appsettings.
 *   etc. Sazka:Features:FeAppLoggerSegmentsEnabled: "bonusomat;golden-wheel"
 * */

const appSettings = typeof window !== "undefined" && (window as any).appSettings ? (window as any).appSettings : {};

const enabledSegments: AppLogggerSegmentNames[] = appSettings
    ? (appSettings["Features:FeAppLoggerSegmentsEnabled"]?.split(";") as AppLogggerSegmentNames[]) ?? []
    : [];

const isEnabledAllTrafic = enabledSegments.some((enableSegmentName) => enableSegmentName == "all");

/**
 * Log event to console and app insights
 * @param codename Short event name string (code name of event)
 * @param properties Custom data to log
 */
export const logEvent = (codename: string, properties: Record<string, any> = {}) => {
    console.log(codename, properties);
    trackEvent(codename, properties);
};

/**
 * Log event to console and app insights if segmets debug mode is enabled
 * @param segmentName The name of the segment that must be enabled to send the event
 * @param codename Short event name string (code name of event)
 * @param properties Custom data to log
 */
export const logDebugEvent = (
    segmentName: AppLogggerSegmentNames,
    codename: string,
    properties: Record<string, any> = {}
) => {
    if (isEnabledAllTrafic || enabledSegments.some((enableSegmentName) => enableSegmentName == segmentName)) {
        logEvent(codename, { segmentName: segmentName, ...properties });
    }
};

/**
 * Log exception to console and app insights. *
 * @param codename  Short exception name string (code name of event)
 * @param exception Object from the exception (try..catch value)
 * @param properties Custom data to log
 */
export const logException = (
    codename: string,
    exception: Error | AxiosError | unknown,
    properties: Record<string, any> = {}
) => {
    if (exception instanceof AxiosError && exception.response?.data) {
        exception = new Error(JSON.stringify(exception.response.data));
    } else if (!(exception instanceof Error)) {
        exception = new Error(JSON.stringify(exception));
    }

    console.error(codename, exception, properties);
    trackException(exception as Error, { codename: codename, ...properties });
};

/**
 * Log custom exception to console and app insights.
 * @param codename  Short exception name string (code name of event)
 * @param message Short message of error
 * @param properties Custom data to log
 */
export const logCustomException = (codename: string, message: string, properties: Record<string, any> = {}) => {
    const error = new Error(message);

    console.error(codename, error, properties);
    logException(codename, error, properties);
};

/**
 * Log some metric to app insights
 */
export const logMetric = trackMetric;
